import { Box, Tooltip } from "@mui/material";
import moment from "moment";
import React, { useCallback, useState } from "react";

type FormatType = "text" | "number" | "accounting" | "date" | "select" | "boolean";
type ValueType = string | number | Date | null | undefined;

export const formatNumberAndCurrency = (value: number | null, isCurrency = false): string => {
  if (value === null || value === undefined) return "-";
  if (typeof value !== "number") return value;
  if (isNaN(value)) return "-";
  const hasDecimal = value % 1 !== 0;
  const formatted = value.toLocaleString("en-IN", {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: hasDecimal ? 2 : 0,
  });
  if (isCurrency) return `₹ ${formatted}`;
  else return formatted;
};

function formatCellValue(value: ValueType, type: FormatType): string {
  switch (type) {
    case "number":
      return formatNumberAndCurrency(value as number, false);
    case "accounting":
      return formatNumberAndCurrency(value as number, false);
    case "date": {
      const date = moment(value);
      if (!date.isValid()) return "-";
      return date.format("DD/MM/YYYY");
    }
    case "boolean": {
      return value ? "Yes" : "No";
    }
    default:
      return value ? String(value) : "-";
  }
}

const EllipsisedCell = ({ value, type }: { value: ValueType; type: FormatType }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const checkOverflow = useCallback((el: HTMLDivElement | null) => {
    if (el) {
      const isOverflowing = el.scrollWidth > el.clientWidth;
      setShowTooltip(isOverflowing);
    }
  }, []);

  return (
    <Tooltip
      title={showTooltip ? formatCellValue(value, type) : ""}
      placement={"top"}
      arrow
      disableHoverListener={!showTooltip}
    >
      <Box
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        ref={checkOverflow}
      >
        {formatCellValue(value, type)}
      </Box>
    </Tooltip>
  );
};

export default EllipsisedCell;
